export const timeLineFormatTime = (time: number | string, withHours?: boolean) => {
  if (Number.isNaN(time)) {
    return '00:00';
  }
  const date = new Date(Number(time) * 1000);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');
  if (hours || withHours) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds} `;
  }
  return `${minutes}:${seconds}`;
};
